import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { CONTACT, NAV } from "@/lib/content";

const Footer = () => {
  return (
    <footer className="bg-navy text-white" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-12 py-16 lg:py-20">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Logo variant="onDark" />
            <p className="mt-6 max-w-md text-[15px] leading-relaxed text-white/70">
              Bright EOR helps UK businesses hire, onboard and manage India-based remote staff through EOR support, payroll coordination and managed offshore support.
            </p>
            <p className="mt-6 text-xs uppercase tracking-[0.22em] text-aqua/80">Part of Brightridge Partners</p>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs uppercase tracking-[0.22em] text-white/50">Explore</p>
            <ul className="mt-5 space-y-3">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link
                    to={n.to}
                    data-testid={`footer-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-[15px] text-white/80 hover:text-aqua transition-colors"
                  >
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="text-xs uppercase tracking-[0.22em] text-white/50">Contact</p>
            <ul className="mt-5 space-y-4 text-[15px]">
              <li className="flex items-start gap-3">
                <Mail className="h-4 w-4 mt-1 text-aqua shrink-0" />
                <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="text-white/85 hover:text-aqua transition-colors">
                  {CONTACT.email}
                </a>
              </li>
              {CONTACT.phones.map((p) => (
                <li key={p.number} className="flex items-start gap-3">
                  <Phone className="h-4 w-4 mt-1 text-aqua shrink-0" />
                  <div>
                    <a href={p.href} data-testid={`footer-phone-${p.number.replace(/\s/g, "")}`} className="text-white/85 hover:text-aqua transition-colors">
                      {p.number}
                    </a>
                    <p className="text-xs text-white/50">{p.label}</p>
                  </div>
                </li>
              ))}
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 mt-1 text-aqua shrink-0" />
                <span className="text-white/70">United Kingdom · India</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-white/50">© {new Date().getFullYear()} Bright EOR. All rights reserved.</p>
          <div className="flex items-center gap-6 text-xs text-white/50">
            <a href="#" className="hover:text-aqua transition-colors">Privacy</a>
            <a href="#" className="hover:text-aqua transition-colors">Terms</a>
            <a href="#" className="hover:text-aqua transition-colors">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
